import { APP_TOKEN } from "../helpers/constants"; // import constants

import { extractToken } from "../helpers/utilities"; // import utilities

export const headers = (authentified = true, acceptJson = true) => {
  let apiHeader = acceptJson
    ? { Accept: "application/json", "Content-Type": "application/json" }
    : {};
  if (authentified) apiHeader.Authorization = `Bearer ${extractToken()}`;
  return apiHeader;
};

const formatBaseUrl = (url) => {
  if (!url || url.length === 0) {
    return "";
  }
  return url[0] === '"' ? JSON.parse(url) : url;
};

// const BASE_URL = formatBaseUrl(process.env.REACT_APP_BASE_URL)
// export const BASE_URL = 'https://api-dev.aceorientation.com/api/'; dev server
// export const BASE_URL="http://192.168.0.135:8080/api/";
// export const WEBSITE_URL ="http://192.168.0.135:8080/api/";
// export const BASE_URL="http://13.201.112.67/ace-api/public/index.php/api/" //server api
// export const WEBSITE_URL="http://aceapi.digital4design.in/api/"
//export const WEBSITE_URL="http://192.168.0.144:8080/api/"
export const BASE_URL ="https://digital4design.ca/ace-api/src/public/index.php/api/";
export const WEBSITE_URL ="https://digital4design.ca/ace-api/src/public/index.php/api/";

export const upload = async (route, data, method, authentified = false) => {
  try {
    const response = await fetch(`${BASE_URL}${route}`, {
      method: method,
      headers: headers(authentified, false),
      body: data,
    });
    const json = await response.json();
    return json;
  } catch (error) {
    return console.error(error);
  }
};

export const get = async (route ,authentified = true) => {
  try {
    const response = await fetch(`${BASE_URL}${route}`, {
      method: "GET",
      headers: headers(authentified),
    });
    const json = await response.json();
    return json;
  } catch (error) {
    return console.error(error);
  }
};

export const post = async (route, data, authentified = true) => {
  try {
    const response = await fetch(`${BASE_URL}${route}`, {
      method: "POST",
      headers: headers(authentified),
      body: JSON.stringify(data),
    });
    const json = await response.json();
    return json;
  } catch (error) {
    return console.error(error);
  }
};

export const patch = async (route, data, authentified = true) => {
  try {
    const response = await fetch(`${BASE_URL}${route}`, {
      method: "PATCH",
      headers: headers(authentified),
      body: JSON.stringify(data),
    });
    const json = await response.json();
    return json;
  } catch (error) {
    return console.error(error);
  }
};

export const put = async (route, data, authentified = true) => {
  try {
    const response = await fetch(`${BASE_URL}${route}`, {
      method: "PUT",
      headers: headers(authentified),
      body: data !== "" ? JSON.stringify(data) : data,
    });
    const json = await response.json();
    return json;
  } catch (error) {
    return console.error(error);
  }
};

export const destroy = async (route, authentified = true) => {
  try {
    const response = await fetch(`${BASE_URL}${route}`, {
      method: "DELETE",
      headers: headers(authentified),
    });
    const json = await response.json();
    return json;
  } catch (error) {
    return console.error(error);
  }
};
